<template>
  <div>
    <div v-if="opr && opr.length">
      <div class="d-flex flex-between my-3">
        <h4 class="text-uppercase mb-0">Tindakan Operasi</h4>
        <router-link
          :to="
            `/operasi/form-tindakan/${$route.params.id_ralan}/${$route.params.id}?fromTab=1`
          "
          class="btn btn-with-icon-left btn-primary text-uppercase"
        >
          <i class="material-symbols-outlined">create</i>
          Ubah Data Tindakan
        </router-link>
      </div>
      <div class="row my-3">
        <div class="col-md-12" style="position:relative">
          <!-- <div class="form-group">
                <div class="input-group">
                    <input type="text" :class="'form-control form-control-lg pl-5 with-icon-left without-label '+(isError?'error':'')" placeholder="Cari kode atau nama tindakan di sini" @input="(e)=>{a_opr=false;s_opr=e.target.value;}" :value="s_opr" v-on:keyup.enter="()=>search('opr')">
                    <i class="material-symbols-outlined" style="margin-top:-.25rem">search</i>
                    <div class="input-group-append">
                        <button class="btn btn-secondary btn-with-icon-left" @click="()=>search('opr')">
                            <i class="material-symbols-outlined">search</i>
                            CARI
                        </button>
                    </div>
                </div>
            </div> -->
          <!-- <SearchResult type="" @addItem="(item)=>addItem(item,'opr')" v-if="s_opr && a_opr" :loading="l_opr" :data="r_opr" /> -->

          <table v-if="opr.length" class="responsive">
            <thead>
              <th>KODE</th>
              <th>NAMA TINDAKAN</th>
              <th>KATEGORI TINDAKAN</th>
              <th>TARIF/BIAYA</th>
              <!-- <th></th> -->
            </thead>
            <tbody>
              <tr
                v-for="item in opr.filter((item) => !item.deleted)"
                v-bind:key="item.id + Math.random(1024)"
              >
                <td>{{ item.kode }}</td>
                <td>{{ item.nama }}</td>
                <td>{{ item.kategori }}</td>
                <td>{{ item.formatted_biaya }}</td>
                <!-- <td>
                            <button class="btn btn-icon btn-danger btn-sm" @click="()=>deleteItem('opr',item.id)">
                                <i class="material-symbols-outlined">delete</i>
                            </button>
                        </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <EmptyState v-else :data="empty" />
  </div>
</template>

<script>
// @ is an alias to /src
// import SearchResult from '@/components/SearchResult.vue'
import { convertToRupiah } from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import { dataOperasi } from "@/data/OperasiForm.js";
import EmptyState from "@/components/EmptyState.vue";
export default {
  props: { ralan: Object, operasi: Object },
  name: "OperasiFormTindakan",
  components: {
    EmptyState,
    // SearchResult
  },
  data: () => {
    return {
      empty: {
        img: "/img/nurse.svg",
        title: "Belum ada tindakan operasi",
        content:
          "Isi data tindakan operasi dengan mengeklik tombol di bawah ini",
        size: "small",
        link: "/operasi/form-tindakan/",
        label: "input tindakan operasi",
      },
      data: dataOperasi,
      detailTop: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      id_operasi: null,
      n: 0,
      s_opr: "",
      r_opr: [],
      opr: [],
      a_opr: false,
      l_opr: false,
      saveSuccess: false,
      saveFailed: false,
      isError: false,
    };
  },
  methods: {
    save: async function() {
      this.handleForm();
    },
    continue: function() {
      this.$router.push(
        `/operasi/form-obat/${this.$route.params.id_ralan}/${this.$route.params.id}`
      );
    },
    saveAndContinue: async function() {
      this.handleForm(this.continue);
    },
    handleForm: async function() {
      let self = this;
      self.errors = [];
      self.n = this.opr.filter(
        (item) => !(item.deleted && !item.id_operasi_tindakan)
      ).length;

      this.opr.forEach(async function(item) {
        //n-=1;
        if (!item.deleted) {
          let body = `id_operasi=${self.id_operasi}&id_tindakan=${item.id}&biaya=${item.biaya}`;
          if (!item.id_operasi_tindakan) {
            self.saveTindakan(body);
          } else {
            self.saveTindakan(body, item.id_operasi_tindakan);
          }
        } else {
          if (item.id_operasi_tindakan) {
            self.deleteTindakan(item.id_operasi_tindakan);
          }
        }
      });
    },
    async saveTindakan(body, id) {
      try {
        if (id) {
          let result = await this.$store.state.HTTP_ENC.put(
            `operasi_tindakan/${id}`,
            body
          );
          ////console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        } else {
          let result = await this.$store.state.HTTP_ENC.post(
            `operasi_tindakan`,
            body
          );
          ////console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        }
      } catch (e) {
        ////console.log(e);this.saveFailed=true;this.saveSuccess=false;
      }
    },
    async deleteTindakan(id) {
      try {
        let result = await this.$store.state.HTTP_ENC.delete(
          `operasi_tindakan/${id}`
        );
        ////console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        }
      } catch (e) {
        ////console.log(e);this.saveFailed=true;this.saveSuccess=false;
      }
    },
    fetchData: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi_tindakan?id_operasi=${this.$route.params.id}`
        );
        ////console.log(result);
        let self = this;
        self.opr = [];
        if (result.status == "200") {
          let tindOpr = result.data.data;
          tindOpr.forEach((item) => {
            item.nama = item.tindakan.nama;
            item.formatted_biaya = convertToRupiah(item.biaya);
            item.kategori = item.tindakan.kategori;
            item.kode = item.tindakan.kode;
            item.id_operasi_tindakan = item.id;
            item.id = item.tindakan.id;
            self.opr.push(item);
          });
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    search: async function(type) {
      ////console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;

      let url = "tindakan";
      try {
        let result = await this.$store.state.HTTP.get(
          `${url}?q=${this["s_" + type]}`
        );
        ////console.log(result);
        if (result.status == "200") {
          // this['r_'+type]=result.data;
          let self = this;
          this["r_" + type] = result.data.map(function(item) {
            if (type == "lab") {
              item.biaya =
                self.formSet.lab_type == "Dewasa"
                  ? item.biaya_dewasa
                  : item.biaya_anak;
            }
            item.formatted_biaya = convertToRupiah(item.biaya);
            return item;
          });
          ////console.log(this['r_'+type]);
          self["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          self["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      if (!this[type].find((el) => el.id == item.id)) {
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      ////console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      ////console.log(this[type]);
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          that.$router.push(
            `/operasi/form-obat/${that.$route.params.id_ralan}/${that.$route.params.id}`
          );
        }, 1000);
      }
    },
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.empty.link +=
      this.$route.params.id_ralan + "/" + this.$route.params.id + "?fromTab=1";
    this.id_operasi = this.$route.params.id;
    await this.fetchData();
  },
};
</script>
